import React from 'react';

import { makeStyles } from '@gogame/ui/styles';
import Stack from '@gogame/ui/Stack';
import Typography from '@gogame/ui/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 49,
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: '0 16px',
  },
  actions: { paddingRight: 4 },
}));

const ListToolbar = ({ title, actions }) => {
  const classes = useStyles();
  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      className={classes.root}
    >
      <Typography>{title}</Typography>
      <Stack className={classes.actions}>{actions}</Stack>
    </Stack>
  );
};
export default ListToolbar;
